import axios from 'axios';

const isUrlValid = (url: string): boolean => {
    if (url?.startsWith('http')) {
        return true;
    }

    console.error('Endpoint not found in configuration', url);
    return false;
};

const ApiService = {
    /**
     * Makes a GET call through axios
     * @param url URL of the API to call
     * @param customHeaders Any custom headers to pass to the axios call
     */
    async get({
        url,
        customHeaders = {},
    }: {
        url: string;
        customHeaders?: Record<string, unknown>;
    }): Promise<unknown> {
        if (isUrlValid(url) === false) {
            throw new Error('Service endpoint is not valid');
        }

        const response = await axios({
            url,
            method: 'GET',
            metadata: {
                customHeaders,
            },
        });

        return response;
    },

    /**
     * Makes a POST call through axios
     * @param url URL of the API to call
     * @param body JSON body of the POST API call
     * @param customHeaders Any custom headers to pass to the axios call
     */
    async post({
        url,
        body = {},
        customHeaders = {},
    }: {
        url: string;
        body?: Record<string, unknown> | string | string[];
        customHeaders?: Record<string, unknown>;
    }): Promise<unknown> {
        if (isUrlValid(url) === false) {
            throw new Error('Service endpoint is not valid');
        }

        const response = await axios({
            url,
            method: 'POST',
            data: body,
            metadata: {
                customHeaders,
            },
        });

        return response;
    },
};

export default ApiService;
